import { StripeMessage } from './MemberPaymentContext.interface';

import { MemberStatus } from 'modules/common/interfaces/member';
import { UpdateStripePaymentResponse } from 'services/member/mutations/useUpdateStripePayment/useUpdateStripePayment.interface';

export const MemberPaymentActionType = {
    OPEN_MODAL: 'OPEN_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL',
    SET_TOKEN: 'SET_TOKEN',
    SET_TOS_CHECKED: 'SET_TOS_CHECKED',
    SET_MESSAGE: 'SET_MESSAGE',
    RESET_MESSAGE: 'RESET_MESSAGE',
    SET_UPDATING: 'SET_UPDATING',
    RESET: 'RESET',
} as const;

export default function mapStripeUpdateResponseToMessage(
    result: UpdateStripePaymentResponse,
    firstStatus: MemberStatus | undefined
): Partial<StripeMessage> {
    if (result.success) {
        return {
            isSuccess: true,
            firstTime: false,
            message: 'Your payment method is successfully updated.',
            messageLine1: '',
            messageLine2: '',
        };
    }

    if (firstStatus === MemberStatus.PAYMENT_ERROR) {
        return {
            isSuccess: false,
            firstTime: false,
            message: 'There was a problem processing your payment. Please check your details and try again.',
            messageLine1: result.result?.message ?? '',
            messageLine2: result.result?.doc_url ?? '',
        };
    }

    return {
        isSuccess: false,
        firstTime: false,
        message: `There was a problem updating your new payment method. Please check your details and try again. ${
            result.result?.message ?? ''
        }`,
        messageLine1: '',
        messageLine2: '',
    };
}
